import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/editor-picks")({
  component: lazyRouteComponent(() => import("./-pages/admin.editor-picks")),
  head: () => ({
    meta: [{ title: "Editor Picks · Lecmo Admin" }, { name: "robots", content: "noindex" }],
  }),
});
